import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram, Star, ArrowUp } from "lucide-react";
import { LotusMark } from "./LotusMark";
import { site } from "../../config/site";
import { CITIES } from "../../data/content";
import { scrollToSection as scrollTo } from "./lenis";


const navLinks = [
  { label: "Home", id: "hero" },
  { label: "Services", id: "services" },
  { label: "Gallery", id: "gallery" },
  { label: "Reviews", id: "testimonials" },
  { label: "FAQ", id: "faq" },
  { label: "Get a Quote", id: "quote" },
];

export const Footer = () => (
  <footer className="relative bg-[#0a0a0a] border-t border-white/10 pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5">
            <LotusMark size={44} />
            <span className="leading-none">
              <span className="block font-heading font-extrabold tracking-tight text-2xl text-white">LOTUS</span>
              <span className="block text-[10px] tracking-[0.3em] text-[#53C653] font-semibold">PROPERTY SERVICES</span>
            </span>
          </div>
          <p className="font-script text-3xl text-[#F56FB4] mt-5">Every property deserves to bloom.</p>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Facebook, href: site.social.facebook, label: "Facebook" },
              { Icon: Instagram, href: site.social.instagram, label: "Instagram" },
              { Icon: Star, href: site.social.google, label: "Google Reviews" },
            ].map(({ Icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`social-${label.toLowerCase().replace(/\s/g, "-")}`}
                className="h-11 w-11 rounded-full border border-white/12 flex items-center justify-center text-white/70 hover:text-white hover:border-[#F56FB4] hover:bg-[#F56FB4]/10 transition-colors duration-200">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        {/* Nav */}
        <div>
          <h4 className="font-heading font-bold uppercase text-white text-sm tracking-wider mb-5">Explore</h4>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.id}>
                <button data-testid={`footer-nav-${l.id}`} onClick={() => scrollTo(l.id)} className="text-white/60 hover:text-[#F56FB4] transition-colors duration-200 text-sm">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Service area */}
        <div>
          <h4 className="font-heading font-bold uppercase text-white text-sm tracking-wider mb-5">Service Area</h4>
          <ul className="space-y-2.5">
            {CITIES.slice(0, 7).map((c) => (
              <li key={c} className="text-white/60 text-sm">{c}</li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading font-bold uppercase text-white text-sm tracking-wider mb-5">Get in Touch</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <Phone size={18} className="text-[#F56FB4] mt-0.5 shrink-0" />
              <span className="text-white/70 text-sm">{site.phoneDisplay}</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} className="text-[#53C653] mt-0.5 shrink-0" />
              <span className="text-white/70 text-sm break-all">{site.email}</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-[#F56FB4] mt-0.5 shrink-0" />
              <span className="text-white/70 text-sm">{site.serviceAreaShort}</span>
            </li>
          </ul>
          <p className="text-white/40 text-xs mt-5">{site.hours}</p>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-white/40 text-sm">© {new Date().getFullYear()} Lotus Property Services. All rights reserved.</p>
        <button onClick={() => scrollTo("hero")} data-testid="back-to-top" className="inline-flex items-center gap-2 text-white/50 hover:text-white transition-colors text-sm">
          Back to top <ArrowUp size={16} />
        </button>
      </div>
    </div>
  </footer>
);

export default Footer;
